import { Status } from 'feature/statuses/types'
import { TAppealStatusCrm } from '../types'

export const getAppealStatusChipData: Record<
  TAppealStatusCrm,
  { status: Status; label: string }
> = {
  'C5:PREPAYMENT_INVOICE': {
    status: 'progress',
    label: 'Ожидает подтверждения',
  },
  'C5:UC_YHAZEV': { status: 'progress', label: 'На проверке ' },
  'C5:LOSE': { status: 'canceled', label: 'Отменено' },
  'C5:WON': { status: 'done', label: 'Завершено' },
}
